import FONDO from "../assets/fondoLav.jpeg";

const Solicitar = () => {
  return (
    <div className="relative w-full bg-white">
      {/* Fondo con imagen fija */}
      <div
        className="relative w-full bg-cover bg-center bg-fixed"
        style={{ backgroundImage: `url(${FONDO})` }}
      >
        {/* Filtro azul */}
        <div className="absolute inset-0 bg-blue-900/80 border-y-2 border-white"></div>

        {/* Diagonal arriba */}
        <div className="absolute top-0 left-0 w-full h-16 bg-white clip-path-diagonal-top"></div>

        {/* Contenido */}
        <div className="relative w-full flex flex-col items-center py-16 px-4">
          <h3 className="text-sky-300 font-semibold text-3xl font-bold">Contáctenos</h3>
          <p className="text-white mb-8 text-center max-w-xl">
            Rellene el siguiente formulario o póngase en contacto con nosotros a
            través del 222 863 0029
          </p>

          <form className="w-full max-w-3xl flex flex-col gap-4">
            <div className="w-full flex flex-col md:flex-row gap-4">
              <input
                type="text"
                placeholder="Nombre completo"
                className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
              />
              <input
                type="email"
                placeholder="Correo electrónico"
                className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
              />
            </div>
            <input
              type="tel"
              placeholder="Teléfono"
              className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
            />
            <input
              type="text"
              placeholder="Ciudad desde la que escribe"
              className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
            />
            <textarea
              rows="4"
              placeholder="Mensaje"
              className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400 resize-none"
            ></textarea>

            <button
              type="submit"
              className="w-full bg-white text-black py-3 rounded-full font-semibold transition"
            >
              Enviar
            </button>
          </form>
        </div>

        {/* Diagonal abajo */}
        <div className="absolute bottom-0 left-0 w-full h-16 bg-white clip-path-diagonal-bottom"></div>
      </div>
    </div>
  );
};

export default Solicitar;
